<template>
  <div id="contenedor-main-contrato-directorio">
    <v-card
    flat>
    <v-card-text>
      <!-- ToolBar -->
      <tool-bar
        v-if="!$apollo.queries.contratoDirectorios.loading"
        class="my-3"
        v-on:nuevoDirectorio="registrarNuevoDirectorio">
      </tool-bar>
      <!-- Loader -->
      <v-skeleton-loader
        v-if="$apollo.queries.contratoDirectorios.loading"
        type="table-heading, table-thead, table-tbody"
      >
      </v-skeleton-loader>
      <listado
          v-if="!$apollo.queries.contratoDirectorios.loading && contratoDirectorios.length > 0"
          :listado="getListadoDirectorio">
        </listado>
        <!-- Mensaje de alertar de que no existe frentes registrados -->
        <v-alert
          v-else
          type="info">
          No se encontraron registros.
        </v-alert>
      </v-card-text>
    </v-card>
    <!-- Agregar contrato directorio -->
    <v-dialog
      v-model="mostrarRegistrarDirectorio"
      width="450">
      <agregar-directorio
        :id-contrato="$route.params.idContrato"
        v-on:cerrar="cerrarVentana">
      </agregar-directorio>
    </v-dialog>
    <!-- Editar contrato directorio -->
    <v-dialog
      v-model="mostrarEditarDirectorio"
      width="450">
      <editar-directorio
        v-if="esteDirectorio"
        :directorio-editar="esteDirectorio"
        v-on:cerrar="cerrarVentana">
      </editar-directorio>
    </v-dialog>
    <!-- Borrar contrato directorio -->
    <v-dialog
      v-model="mostrarEliminarDirectorio"
      width="450">
      <eliminar-directorio
      v-if="esteDirectorio"
        :directorio-eliminar="esteDirectorio"
        v-on:cerrar="cerrarVentana">
      </eliminar-directorio>
    </v-dialog>
  </div>
</template>

<script>
import CONTRATO_DIRECTORIOS from '@/graphql/querys/administracion/contratos/contrato/directorios/contratoDirectorios.gql';
import eventBus from '@/helpers/eventBus';
import agregarDirectorio from '@/components/administracion/contratos/contrato/directorios/Nuevo.vue';
import editarDirectorio from '@/components/administracion/contratos/contrato/directorios/Editar.vue';
import eliminarDirectorio from '@/components/administracion/contratos/contrato/directorios/Eliminar.vue';
import ToolBar from './ToolBar.vue';
import listado from './listado/Main.vue';

export default {
  name: 'MainContratoDirectorio',
  components: {
    ToolBar,
    agregarDirectorio,
    editarDirectorio,
    eliminarDirectorio,
    listado,
  },
  data() {
    return {
      mostrarRegistrarDirectorio: false,
      mostrarEditarDirectorio: false,
      mostrarEliminarDirectorio: false,
      esteDirectorio: null,
    };
  },
  mounted() {
    eventBus.$on('editar-directorio-contrato', (directorio) => {
      this.esteDirectorio = directorio;
      this.mostrarEditarDirectorio = true;
    });
    eventBus.$on('eliminar-directorio-contrato', (directorio) => {
      this.esteDirectorio = directorio;
      this.mostrarEliminarDirectorio = true;
    });
  },
  apollo: {
    contratoDirectorios: {
      query: CONTRATO_DIRECTORIOS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  methods: {
    registrarNuevoDirectorio() {
      this.mostrarRegistrarDirectorio = true;
    },
    cerrarVentana() {
      this.mostrarRegistrarDirectorio = false;
      this.mostrarEditarDirectorio = false;
      this.mostrarEliminarDirectorio = false;
      this.esteDirectorio = null;
    },
  },
  computed: {
    getListadoDirectorio() {
      if (!this.contratoDirectorios) return [];
      return this.contratoDirectorios.slice()
        .sort((a, b) => {
          if (a.tipo !== b.tipo) {
            return a.tipo - b.tipo;
          }
          return a.nombre.localeCompare(b.nombre);
        });
    },
  },
};
</script>

<style lang="scss">

</style>
